export default {
  emptyState: "No forecasters for this site.",
  forecasterTitle: "Forecasters"
};
